import angular from 'angular';

import {TopHeader} from './top-header.component';

import SendNoteController from './send-note.controller.js';

import './top-header.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.layout.topHeader', [])
  .component('topHeaderComponent', TopHeader)
  .controller('SendNoteController', SendNoteController)
  .name;
